// mainRole is written alongside primaryRole so onboarding alone is enough for
// admin search/dashboard to see the role. Omitted when empty so it can't wipe
// a mainRole previously set from the Profile page.
export const buildExperiencePayload = (data) => {
  const role = data.primaryRoles?.[0] || '';
  return {
    seniority: data.seniority || '',
    primaryRole: role,
    ...(role && { mainRole: role }),
    roles: data.primaryRoles || [],
    otherPrimaryRole: data.otherPrimaryRole || '',
  };
};
